<template>
  <a-cascader
    v-model:value="value"
    :options="departemnt"
    @change="handleSearch"
    placeholder="申请部门"
    :fieldNames="{
       label: 'structureName',
       value: 'structureName',
    }"
    allowClear
    style="width: 160px"
  />
</template>

<script setup>
import { computed, ref, defineEmits } from "vue";
import { useStore } from "vuex";
import { loDepartment } from "../options";
import { getStructure } from '@/request/view/personal.js';

const store = useStore();

const value = ref();

getStructure().then((res) => {
    if (res.code === 200 && res.data && res.data[0].children) {
        const value = res.data[0].children;
        departemnt.value = value.filter((f) => loDepartment.find((l) => f.structureName === l ));
    }
});

const departemnt = ref([]);

const emit = defineEmits(["handleSearch"]);

const handleSearch= () => {
    emit('handleSearch', value.value[value.value.length - 1]);
};

</script>

<style lang="less" scoped></style>
